export const PendoXSRFToken = 'PendoXSRFToken';

export const PendoXSRFTokenC80 = 'PendoXSRFToken_C80';

export function getCookie (cookieString, cookieName) {
    const cookie = {};
    cookieString.split(';').forEach((el) => {
        // eslint-disable-next-line id-length
        const [k, v] = el.split('=');
        cookie[k.trim()] = v;
    });

    return decodeURI(cookie[cookieName] || '');
}
